import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { OTH, MMD, CPF, ADM, LOC, PSO, FC, DIS, LOCchange, AdmitOrder, DischargeOrder, GeneralOrder, FACchange, PSOorder, PRNOrder, MedicationChange, CPVisitFrequencies, FOR_CAUSE_NAME, LEFT_GEOGRAPHIC_AREA_NAME, NON_CERTIFIED_NAME } from './orders-constants';
export const conversationTypes = [{
  id: 'phone',
  label: 'phone',
  value: 'phone'
}, {
  id: 'verbal',
  label: 'verbal',
  value: 'verbal'
}, {
  id: 'electronic',
  label: 'secure electronic',
  value: 'secure electronic'
}];
export const mapTitle = {
  LOC: LOCchange,
  ADM: AdmitOrder,
  DIS: DischargeOrder,
  OTH: GeneralOrder,
  FC: FACchange,
  PSO: PSOorder,
  PRN: PRNOrder,
  MMD: MedicationChange,
  CPF: CPVisitFrequencies
};
export const mapOrderName = _objectSpread(_objectSpread({}, mapTitle), {}, {
  FOR_CAUSE: FOR_CAUSE_NAME,
  LEFT_GEOGRAPHIC_AREA: LEFT_GEOGRAPHIC_AREA_NAME,
  NON_CERTIFIED: NON_CERTIFIED_NAME
});
export const orderTypeMapping = {
  OTH,
  MMD,
  CPF,
  ADM,
  LOC,
  PSO,
  FC,
  DEATH: DIS,
  REVOKED: DIS,
  TRANSFERRED: DIS,
  FOR_CAUSE: DIS,
  LEFT_GEOGRAPHIC_AREA: DIS,
  NON_CERTIFIED: DIS,
  PRN: CPF
};